<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
  >
    <path d="M32,2C14.88,2,1,15.88,1,33s13.88,31,31,31,31-13.87,31-31S49.12,2,32,2h0Z" />
    <path
      fill="#fff"
      d="M32,4.5c15.72,0,28.5,12.78,28.5,28.5s-12.78,28.5-28.5,28.5S3.5,48.71,3.5,33,16.29,4.5,32,4.5Z"
    />
    <path d="M32,7c-14.34,0-26,11.66-26,26s11.66,26,26,26,26-11.66,26-26S46.34,7,32,7h0Z" />
    <polygon
      fill="#fff"
      points="31.33 14.5 42.11 14.5 33.89 28.91 43.03 28.91 24.53 53.14 29.92 35.98 20.97 35.98 31.33 14.5"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'DataCenterProjectIcon',
};
</script>
